import React, { useState, useEffect } from "react";
import { GetAllSurvey } from "../../../services/SurveyService";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import NormalAlert from "../../AlertComponent/NormalAlert";

const SurveyList = () => {
  const [surveys, setSurveys] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [alert, setAlert] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const response = await GetAllSurvey();
        if (response?.data?.assessmentList) {
          setSurveys(response.data.assessmentList);
        }
      } catch (error) {
        const safeMessage =
          error?.response?.data?.message ||
          "Something went wrong. Please try again.";

        setAlert({
          type: "fail",
          message: safeMessage,
        });
      }
    };

    fetchSurveys();
  }, []);

  const handleEditSurvey = (assessmentUID) => {
    navigate(`/Dashboard/Survey/CreateQuestion/${assessmentUID}`);
  };

  const filteredSurveys = surveys.filter(
    (s) =>
      s.assessmentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      s.createdBy.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredSurveys.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentSurveys = filteredSurveys.slice(indexOfFirst, indexOfLast);

  return (
    <>
      <div className="container mt-5 pt-4">
        <h4 className="text-center mb-4">Survey List</h4>

        {/* Search & Add */}
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <div className="d-flex justify-content-between gap-3 flex-wrap mb-3">
            <div className="input-group w-auto">
              <input
                type="text"
                className="form-control"
                placeholder="Search by name or creator"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
            </div>
            <div>
              <label className="me-2 fw-semibold">Records:</label>
              <select
                className="form-select form-select-sm w-auto d-inline-block"
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(parseInt(e.target.value));
                  setCurrentPage(1);
                }}
              >
                {[5, 10, 25, 50, 100].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <Link className="btn btn-primary" to={"/Dashboard/Survey/NewSurvey"}>
            <i className="bi bi-plus-circle"></i> Create New Survey
          </Link>
        </div>

        {/* Table */}
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="bg-primary text-white">
              <tr>
                <th className="px-1 py-3 text-capitlize bg-primary text-white">
                  Sr. No
                </th>
                <th className="px-3 py-3 text-capitlize bg-primary text-white">
                  Survey Name
                </th>
                <th className="px-3 py-3 text-capitlize bg-primary text-white">
                  Created By
                </th>
                <th className="px-3 py-3 text-capitlize bg-primary text-white">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {currentSurveys.length > 0 ? (
                currentSurveys.map((survey, index) => (
                  <tr key={survey.assessmentUID}>
                    <td>{indexOfFirst + index + 1}</td>
                    <td>{survey.assessmentName}</td>
                    <td>{survey.createdBy}</td>
                    <td>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleEditSurvey(survey.assessmentUID)}
                      >
                        <i className="bi bi-eye-fill"></i> Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No surveys found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-center align-items-center mt-3">
          <nav>
            <ul className="pagination mb-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Previous
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default SurveyList;
